var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "mask",
        rawName: "v-mask",
        value: {
          mask: _vm.decimalMask,
          placeholder: _vm.decimalPlaceholder,
          greedy: false,
          showMaskOnHover: false,
        },
        expression:
          "{\n    mask: decimalMask,\n    placeholder: decimalPlaceholder,\n    greedy: false,\n    showMaskOnHover: false\n  }",
      },
    ],
    ref: "input",
    attrs: {
      type: "text",
      name: _vm.name,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
    },
    domProps: { value: _vm.value },
    on: { change: _vm.handleChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }